'use strict';
var allInputs = document.querySelectorAll('form input');
allInputs.forEach(function(input) {
    var label = document.createElement('label');
    label.className = 'field-label';
    label.setAttribute('for', input.id);
    label.textContent = input.name;
    var capitalizedName = input.name.charAt(0).toUpperCase() + input.name.slice(1);
    input.placeholder = capitalizedName;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.ae5230a7.js.map
